import type { BankMatchReason, BankView } from '../../utils/bank-match'

/** The bank account as the finances read it: the inbox of transactions and
 *  the choice of one in the payment dialog. */
export const BANK = {
  title: 'Kontoumsätze',
  notConfigured:
    'Kein Bankkonto verbunden. Hinterlege QONTO_LOGIN und QONTO_SECRET_KEY auf dem Server.',
  sync: 'Jetzt abrufen',
  synced: (n: number) =>
    n === 0
      ? 'Keine neuen Umsätze.'
      : n === 1
        ? '1 Umsatz neu oder geändert.'
        : `${n} Umsätze neu oder geändert.`,
  views: {
    OPEN: 'Offen',
    BOOKED: 'Zugeordnet',
    IGNORED: 'Ignoriert',
  } satisfies Record<BankView, string>,
  empty: {
    OPEN: 'Alle Umsätze sind zugeordnet.',
    BOOKED: 'Noch kein Umsatz zugeordnet.',
    IGNORED: 'Kein Umsatz ignoriert.',
  } satisfies Record<BankView, string>,
  columns: {
    date: 'Datum',
    transaction: 'Umsatz',
    amount: 'Betrag',
    suggestion: 'Vorschlag',
  },
  /** Under the amount, where part of the transfer is booked already. */
  left: (amount: string) => `noch ${amount}`,
  noSuggestion: 'Kein Vorschlag',
  assign: 'Zuordnen',
  pickInvoice: 'Rechnung wählen',
  ignore: 'Ignorieren',
  unignore: 'Zurückholen',
  bookedOn: (number: string) => `Zugeordnet zu ${number}`,
  pickSearch: 'Rechnung, Projekt oder Firma suchen …',
  /** A transfer in a project's Handlungsbedarf, beside the invoice it
   *  most likely pays. */
  queue: {
    badge: 'Kontoumsatz',
    matches: (number: string) => `passt zu ${number}`,
  },
  /** Why a transfer is offered, under it: the reasons, strongest first. */
  matchedBy: (reasons: string) => `erkannt an ${reasons}`,
  /** Why a suggestion is one, as a pill beside it. */
  reasons: {
    NUMBER: 'Rechnungsnummer',
    AMOUNT: 'Betrag',
    PARTY: 'Firma',
  } satisfies Record<BankMatchReason, string>,
  /** The choice of a transaction in the payment dialog. */
  picker: {
    label: 'Kontoumsatz',
    none: 'Ohne Kontoumsatz erfassen',
    empty: 'Kein offener Umsatz in diese Richtung.',
    noSuggestion: 'Kein Umsatz passt zu dieser Rechnung.',
    searchAll: 'Alle offenen Umsätze durchsuchen',
  },
  errors: {
    notConfigured: 'Es ist kein Bankkonto verbunden.',
    unavailable:
      'Die Bank ist gerade nicht erreichbar. Bitte später erneut abrufen.',
    notBookable:
      'Der Umsatz ist nicht gebucht oder ignoriert und kann keine Zahlung belegen.',
    booked:
      'Auf diesen Umsatz sind Zahlungen gebucht; er kann nicht ignoriert werden.',
    wrongWay: 'Der Umsatz geht in die andere Richtung als diese Zahlung.',
    exceeded: (left: string) => `Vom Umsatz sind nur noch ${left} übrig.`,
    amountRequired: 'Gib an, welcher Teil des Umsatzes gebucht wird.',
  },
} as const
